import {BigId, ColonistMembershipType, LobbyImage} from '@colonist/types'
import {StoreItemCategory, StoreItemType} from './entity_datas/StoreEnums'

export const MAX_UNREAD_NOTIFICATION_COUNT = 100

export interface GetNotificationsData {
    date?: Date
    notificationCountToSend: number
}

export interface MarkedAsReadData {
    markAllAsRead?: boolean
    notificationMarkedAsRead?: NotificationData
    unreadNotificationCount: number
}

export interface NotificationData {
    id: BigId
    userId: BigId
    typeData: NotificationTypeData
    dateReceived: Date
    dateRead: Date | undefined
    notificationUserDetails: NotificationUserDetails | undefined
}

export interface NotificationDataWithUnreadCount {
    notifications: NotificationData[]
    unreadNotificationCount: number
    isExistingNotifications?: boolean
}

export enum NotificationTypeEnum {
    UserReportedBanned = 1,
    UserReportedThankYou = 2,
    HolidaySale2023Expired = 3,
    GiftMembershipReceivedFromAdmin = 4,
    TranslationHelp = 5,
    UserReportedWarning = 6,
    LiveRoomInvite = 7,
    RoomInviteResponse = 8,
    MissedRoomInvite = 9,
    FriendRequestReceived = 10,
    YouAreNowFriendsWith = 11,
    GiftMembershipReceivedFromUser = 12,
    GiftMembershipWasSent = 13,
    GiftURLCreated = 14,
    NewUserJoinedFromReferral = 15,
    ReferralRewardItemUnlocked = 16,
    YouAreBanned = 17,
    FreeAvatarUnlocked = 18,
    PushReferrersToInviteMoreFriends = 19, // Not used anymore, do not remove
    GeneralAnnouncement = 20,
    YourFriendMustLogInToCountReferral = 21,
}

// do NOT have icon, username or other details in the typeData. Instead, have the userId and get the NotificationUserDetails when reading the notification
export type NotificationTypeData =
{
    type: NotificationTypeEnum.UserReportedBanned
} | {
    type: NotificationTypeEnum.UserReportedThankYou
} | {
    type: NotificationTypeEnum.HolidaySale2023Expired
} | {
    type: NotificationTypeEnum.GiftMembershipReceivedFromAdmin
} | {
    type: NotificationTypeEnum.TranslationHelp
    language: string
    username: string
    link: string
} | {
    type: NotificationTypeEnum.UserReportedWarning
} | {
    type: NotificationTypeEnum.RoomInviteResponse
    userId: BigId
    response: boolean
} | {
    type: NotificationTypeEnum.MissedRoomInvite
    userId: BigId
} | {
    type: NotificationTypeEnum.YouAreNowFriendsWith
    userId: BigId
} | {
    type: NotificationTypeEnum.GiftMembershipReceivedFromUser
    userId: BigId
    giftMessage: string
} | {
    type: NotificationTypeEnum.GiftMembershipWasSent
    duration: number
    membershipType: ColonistMembershipType
    userId: BigId
} | {
    type: NotificationTypeEnum.GiftURLCreated
    duration: number
    membershipType: ColonistMembershipType
    hash: string
} | {
    type: NotificationTypeEnum.ReferralRewardItemUnlocked
    itemType: StoreItemType
    itemCategory: StoreItemCategory
    referralCount: number
} | {
    type: NotificationTypeEnum.NewUserJoinedFromReferral
    referralLeftCount: number
    username: string
} | {
    type: NotificationTypeEnum.FreeAvatarUnlocked
    itemType: StoreItemType
    itemCategory: StoreItemCategory
} | {
    type: NotificationTypeEnum.YouAreBanned
    untilDate: Date
} | {
    type: NotificationTypeEnum.GeneralAnnouncement
    message: string
} | {
    type: NotificationTypeEnum.YourFriendMustLogInToCountReferral
    username: string
}

export interface NotificationUserDetails {
    username: string
    icon: LobbyImage
    userId: BigId
}
